import { useState, type FormEvent } from 'react';
import { supabase } from '../lib/supabase';
import { Mic2 } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim().toLowerCase(), password });
    setBusy(false);
    if (error) setErr(error.message);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="bg-white rounded-xl shadow-md p-8 w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6">
          <Mic2 className="text-[color:var(--color-primary)]" />
          <h1 className="text-xl font-bold">Seslendirme</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">E-posta</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--color-primary)]"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">Parola</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-slate-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--color-primary)]"
              autoComplete="current-password"
            />
          </div>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-[color:var(--color-primary)] text-white py-2 rounded font-medium disabled:opacity-50"
          >
            {busy ? 'Giriliyor…' : 'Giriş'}
          </button>
        </form>
        <p className="text-xs text-slate-400 mt-4">
          Hesap yoksa master admin'e (Fikret) bildirin. Self-signup kapalı.
        </p>
      </div>
    </div>
  );
}
